// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__38Wc7","label":"Radio_label__3Xg3w","checkMark":"Radio_checkMark__YAGEk","disabled":"Radio_disabled__3103c"};